import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_MLS_UUID,
  FETCH_MLS_UUID_SUCCESS,
  FETCH_MLS_UUID_FAILURE,
] = createRequestConstantNames(cc('FETCH_MLS_UUID'));
